@if (loading === true) {
    <p-progressSpinner class="ps">
    </p-progressSpinner>
}
@else if (loading === false){
    <ng-content>
    </ng-content>
}
